import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ProAct from '../../Actions/ProActions';
import { enregistreInfoFE, verifSiret, obtenirProprietaire } from '../../App_Code/API';
import swal from 'sweetalert2';
import Card from '../Card';
import CardAdresseFE from './CardAdresseFE';

const REGIMES_TVA = {
    0: "Non renseigné",
    1: "Non assujetti",
    2: "Assujetti exonéré",
    3: "Assujetti en franchise en base",
    4: "Assujetti au réel simplifié",
    5: "Assujetti au réel normal mensuel",
    6: "Assujetti au réel normal trimestriel"
};

const CardInfoFE = ({ ProInd, ListeDesPays, actions }) => {
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});

    // Récupération des droits (Index 0 pour les Infos)
    const paramFE = (ProInd && ProInd.ParamAGVisibleFE) ? ProInd.ParamAGVisibleFE : [];
    const droitInfo = paramFE.length > 0 ? paramFE[0] : 0;
    const droitAdresse = paramFE.length > 1 ? paramFE[1] : 0;

    useEffect(() => {
        if (ProInd && ProInd.Ind) {
            const individu = ProInd.Ind;
            const adressePerso = individu.Adresse || {};
            
            setFormData({
                ...individu,
                RaisonSociale: individu.RaisonSociale || individu.Nom || '',
                Ad1RS: individu.Ad1RS || adressePerso.Ad1 || '',
                Ad2RS: individu.Ad2RS || adressePerso.Ad2 || '',
                CpRS: individu.CpRS || adressePerso.Cp || '',
                VilRS: individu.VilRS || adressePerso.Vil || '',
                CodePaysISORS: (individu.CodePaysISORS && individu.CodePaysISORS !== 'ZZ') 
                                ? individu.CodePaysISORS 
                                : (individu.CodePaysISO || 'FR'),
                RegimeTVA: individu.RegimeTVA !== undefined ? individu.RegimeTVA : 0,
                OptionTVASurDebits: individu.OptionTVASurDebits !== undefined ? String(individu.OptionTVASurDebits) : "True"
            });
        }
    }, [ProInd]);

    if (droitInfo === 0 && droitAdresse === 0) return null;
    if (!ProInd || !ProInd.Ind) return <div className="p-4 text-center">Chargement...</div>;

    const handleChange = (e) => {
        if (droitInfo === 1) return; // Sécurité si lecture seule
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: false }));
    };

    const handleValidate = async () => {
        const newErrors = {};
        const requiredFields = ['RaisonSociale', 'Ad1RS', 'CpRS', 'VilRS', 'CodePaysISORS', 'NoTVAIntraCom', 'SIRET'];
        
        requiredFields.forEach(f => {
            if (!formData[f] || String(formData[f]).trim() === '') newErrors[f] = true;
        });

        if (String(formData.RegimeTVA) === '0') newErrors.RegimeTVA = true;

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) {
            swal("Attention", "Veuillez remplir les champs obligatoires.", "warning");
            return;
        }

        const respS = await verifSiret(formData.SIRET);
        if (!respS || respS.status !== 200 || (respS.data && respS.data.valide === false)) {
            swal("Erreur", "SIRET invalide.", "error");
            return;
        }

        const dataToSend = {
            Code: formData.Code || "",
            SIRET: formData.SIRET,
            CodeAPE: formData.CodeAPE,
            RCS: formData.RCS,
            RegimeTVA: String(formData.RegimeTVA),
            TVAMotifExonere: formData.TVAMotifExonere,
            NoTVAIntraCom: formData.NoTVAIntraCom,
            OptionTVASurDebits: String(formData.OptionTVASurDebits),
            RaisonSociale: formData.RaisonSociale,
            Ad1RS: formData.Ad1RS,
            Ad2RS: formData.Ad2RS,
            VilRS: formData.VilRS,
            CpRS: formData.CpRS,
            CodePaysISORS: formData.CodePaysISORS
        };

        const res = await enregistreInfoFE(dataToSend);
        if (res && res.status === 200 && res.data && res.data.success) {
            swal("Succès", "Mise à jour effectuée.", "success");
            obtenirProprietaire().then((pro) => { if (pro) actions.proAjout(pro); });
        }
    };

    const isReadOnly = (droitInfo === 1);

    return (
        <Card Titre="Informations Facturation Electronique">
            {droitInfo > 0 && (
                <div className="saisie p-3">
                    <div className="row mb-3">
                        <div className="col-md-4 lib">Régime TVA *</div>
                        <div className="col-md-8">
                            <select className={"form-select " + (errors.RegimeTVA ? 'is-invalid' : '')} 
                                    name="RegimeTVA" value={formData.RegimeTVA} 
                                    onChange={handleChange} disabled={isReadOnly}>
                                {Object.entries(REGIMES_TVA).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                            </select>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-4 lib">N° TVA Intra *</div>
                        <div className="col-md-8">
                            <input type="text" className={"form-control " + (errors.NoTVAIntraCom ? 'is-invalid' : '')} 
                                   name="NoTVAIntraCom" value={formData.NoTVAIntraCom || ''} 
                                   onChange={handleChange} readOnly={isReadOnly} />
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-4 lib">SIREN / SIRET *</div>
                        <div className="col-md-8">
                            <input type="text" className={"form-control " + (errors.SIRET ? 'is-invalid' : '')} 
                                   name="SIRET" value={formData.SIRET || ''} 
                                   onChange={handleChange} maxLength="14" readOnly={isReadOnly} />
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-4 lib">APE / RCS</div>
                        <div className="col-md-3">
                            <input type="text" className="form-control" name="CodeAPE" value={formData.CodeAPE || ''} onChange={handleChange} maxLength="5" readOnly={isReadOnly} />
                        </div>
                        <div className="col-md-5">
                            <input type="text" className="form-control" name="RCS" value={formData.RCS || ''} onChange={handleChange} readOnly={isReadOnly} />
                        </div>
                    </div>

                    <hr />
                    <div className="row mb-2">
                        <div className="col-md-4 lib">Raison sociale *</div>
                        <div className="col-md-8">
                            <input type="text" className={"form-control " + (errors.RaisonSociale ? 'is-invalid' : '')} 
                                   name="RaisonSociale" value={formData.RaisonSociale || ''} 
                                   onChange={handleChange} readOnly={isReadOnly} />
                        </div>
                    </div>

                    <div className="row mb-2">
                        <div className="col-md-4 lib">Adresse *</div>
                        <div className="col-md-8">
                            <input type="text" className={"form-control mb-1 " + (errors.Ad1RS ? 'is-invalid' : '')} 
                                   name="Ad1RS" value={formData.Ad1RS || ''} 
                                   onChange={handleChange} readOnly={isReadOnly} />
                            <input type="text" className="form-control" name="Ad2RS" value={formData.Ad2RS || ''} 
                                   onChange={handleChange} placeholder="Complément" readOnly={isReadOnly} />
                        </div>
                    </div>

                    {!isReadOnly && (
                        <div className="text-center mt-3">
                            <button type="button" className="btn btn-success" onClick={handleValidate}>Valider mes changements</button>
                        </div>
                    )}
                </div>
            )}

            {droitAdresse > 0 && (
                <CardAdresseFE lectureSeule={droitAdresse === 1} />
            )}
        </Card>
    );
};

function mapStateToProps(state) {
    return {
        ProInd: state.ProStore.Pro,
        ListeDesPays: state.ProStore.Pays
    };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(ProAct, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(CardInfoFE);


// WEBPACK FOOTER //
// ./src/components/MesInfos/CardInfoFE.js